import { render, staticRenderFns } from "./CameraPreview.vue?vue&type=template&id=2a7a5f0a&scoped=true"
import script from "./CameraPreview.vue?vue&type=script&lang=ts"
export * from "./CameraPreview.vue?vue&type=script&lang=ts"
import style0 from "./CameraPreview.vue?vue&type=style&index=0&id=2a7a5f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a5f0a",
  null
  
)

export default component.exports